import { types } from 'mobx-state-tree';
import dayjs from 'dayjs';

import isValidDate from '../functions/isValidDate';


const IsoDateTimeWithOffset = types.custom({
    name: 'IsoDateTimeWithOffset',
    fromSnapshot(value) {
        if (value != null) {
            return dayjs(value).format(); // ISO 8601 with timezone encoded
        }
    },
    toSnapshot(parsedValue) {
        return parsedValue;
    },
    isTargetType(value) {
        return typeof value === 'string' && isValidDate(value);
    },
    getValidationMessage(value) {
        if (isValidDate(value)) return '';
        return `${value} is not a parseable date. Please use a unix timestamp, Date object or ISO 8601 string`;
    },
});

export default IsoDateTimeWithOffset;
